import { useServices } from "contexts/ServiceContext";
import { useMemo } from "react";

const useIsUserLogged = () => {
    const documentCookie = typeof document === "undefined" ? undefined : document.cookie;

    const services = useServices();

    return useMemo(
        () => !!services.AuthApiClient.isLogged(),
        [services.AuthApiClient, documentCookie],
    );
};

export default useIsUserLogged;
